module.exports = __webpack_public_path__ + "img/shoot_00011.c97c6742.png";